<template>
  <div>

    <div class="m-content"
         :style="getAppStyle"
         v-if="getDashboardConfig && getDashboardData">

      <div class="components" v-for="sfc in getDashboardComponents">
        <component
                class='component'
                :is="sfc.type"
                :style="componentStyle(sfc)"
                :config="JSON.parse(sfc.configuration)"
                :dimensions="sfc.dataDimensions"
                :colorTheme="sfc.colorTheme"
                :componentData="getDashboardData[sfc.id]"
        ></component>
      </div>

      <offline-notice></offline-notice>
    </div>
    <div style="background:black;height:100vh;position:fixed;width:100%"v-if="$store.state.dashboardHash == 'off'">
      <p style="position:fixed;bottom:20px;right:20px;" >System offline</p>
    </div>
  </div>
</template>


<script>

  import {mapMutations, mapGetters} from 'vuex'
  import DashboardComponents from 'motivate-dashboarding-components'


  export default {
    components: {
      OfflineNotice: DashboardComponents.CheckConnection
    },
    data() {
      return {
        dashboardData: null,
        dashboardConfig: null
      }
    },
    firestore() {
      return {
        dashboardData: this.$FB.collection('dashboards').doc(this.getDashboardHash ? this.getDashboardHash : 'string '),
        dashboardConfig: this.$FB.collection('dashboardConfigs').doc(this.getDashboardHash ? this.getDashboardHash : 'string ')
      }
    },
    methods: {
      ...mapMutations([
        'setDashboardData',
        'setDashboardConfig'
      ]),
      componentStyle(sfc) {
        return 'top:' + sfc.positionY + 'px;left:' + sfc.positionX + 'px;width:' + sfc.width + 'px;height:' + sfc.height + ';z-index:' + sfc.positionZ + ';'
      }
    },
    computed: {
      getAppStyle() {
        return 'height: ' + this.getDashboardConfig.height + 'px;width:' + this.getDashboardConfig.width + 'px;' + this.getDashboardConfig.css
      },
      ...mapGetters([
        'getDashboardHash',
        'getDashboardData',
        'getDashboardConfig',
        'getDashboardComponents',
        'getComponentConfig'
      ])
    },
    watch: {
      dashboardData: {
        handler: function (newV, oldV) {
          this.setDashboardData(newV)
        },
        deep: true
      },
      dashboardConfig: {
        handler: function (newV, oldV) {
          this.setDashboardConfig(newV)
        },
        deep: true
      }
    },
    created() {

    }
  }

</script>
<style lang="scss">

  html, body {
    width: 100%;
  }

  ::-webkit-scrollbar {
    display: none;
  }

  .components {
    .component {
      position: fixed;
    }
  }


</style>